"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileLayout = exports.setCalculatedSegmentSize = exports.calculatedSegmentSize = exports.setEnableSymmetricalSpecialColor = exports.enableSymmetricalSpecialColor = exports.setInitialFlowerCreationDelayEndTime = exports.initialFlowerCreationDelayEndTime = exports.setInitialCursorVisibilityDelayEndTime = exports.initialCursorVisibilityDelayEndTime = exports.setLogicalGridCells = exports.logicalGridCells = exports.setPostSweepFlowerDelayActiveUntil = exports.postSweepFlowerDelayActiveUntil = exports.setPostSweepFlowerDelayDuration = exports.postSweepFlowerDelayDuration = exports.setStampChance = exports.stampChance = exports.setMainCursorProximityFactor = exports.mainCursorProximityFactor = exports.setAnimationFrameId = exports.animationFrameId = exports.mockUserCursors = exports.setCurrentHoveredMirrorYCell = exports.currentHoveredMirrorYCell = exports.setCurrentHoveredMirrorXCell = exports.currentHoveredMirrorXCell = exports.setCurrentHoveredMirroredCell = exports.currentHoveredMirroredCell = exports.setCurrentHoveredPrimaryCell = exports.currentHoveredPrimaryCell = exports.setSweepStartTime = exports.sweepStartTime = exports.setSweepPauseEndTime = exports.sweepPauseEndTime = exports.setIsSweeping = exports.isSweeping = exports.setSweepLineY = exports.sweepLineY = exports.setCurrentColorPalette = exports.currentColorPalette = exports.setPermanentFlowers = exports.permanentFlowers = exports.setActiveEffects = exports.activeEffects = exports.setBaseLayerCtx = exports.baseLayerCtx = exports.setBaseLayerCanvas = exports.baseLayerCanvas = exports.setLoadedImage = exports.loadedImage = void 0;
exports.setNeedsImageReload = exports.needsImageReload = exports.setImageLayoutMode = exports.imageLayoutMode = exports.setIsMobileLayout = void 0;
var config = __importStar(require("./config.ts"));
exports.loadedImage = null;
var setLoadedImage = function (value) {
    exports.loadedImage = value;
};
exports.setLoadedImage = setLoadedImage;
exports.baseLayerCanvas = null;
var setBaseLayerCanvas = function (value) {
    exports.baseLayerCanvas = value;
};
exports.setBaseLayerCanvas = setBaseLayerCanvas;
exports.baseLayerCtx = null;
var setBaseLayerCtx = function (value) {
    exports.baseLayerCtx = value;
};
exports.setBaseLayerCtx = setBaseLayerCtx;
exports.activeEffects = [];
var setActiveEffects = function (value) {
    exports.activeEffects = value;
};
exports.setActiveEffects = setActiveEffects;
exports.permanentFlowers = [];
var setPermanentFlowers = function (value) {
    exports.permanentFlowers = value;
};
exports.setPermanentFlowers = setPermanentFlowers;
exports.currentColorPalette = [];
var setCurrentColorPalette = function (value) {
    exports.currentColorPalette = value;
};
exports.setCurrentColorPalette = setCurrentColorPalette;
exports.sweepLineY = -1;
var setSweepLineY = function (value) {
    exports.sweepLineY = value;
};
exports.setSweepLineY = setSweepLineY;
exports.isSweeping = false;
var setIsSweeping = function (value) {
    exports.isSweeping = value;
};
exports.setIsSweeping = setIsSweeping;
exports.sweepPauseEndTime = 0;
var setSweepPauseEndTime = function (value) {
    exports.sweepPauseEndTime = value;
};
exports.setSweepPauseEndTime = setSweepPauseEndTime;
exports.sweepStartTime = 0;
var setSweepStartTime = function (value) {
    exports.sweepStartTime = value;
};
exports.setSweepStartTime = setSweepStartTime;
exports.currentHoveredPrimaryCell = null; // Absolute pixel coords
var setCurrentHoveredPrimaryCell = function (value) {
    exports.currentHoveredPrimaryCell = value;
};
exports.setCurrentHoveredPrimaryCell = setCurrentHoveredPrimaryCell;
exports.currentHoveredMirroredCell = null; // Absolute pixel coords
var setCurrentHoveredMirroredCell = function (value) {
    exports.currentHoveredMirroredCell = value;
};
exports.setCurrentHoveredMirroredCell = setCurrentHoveredMirroredCell;
exports.currentHoveredMirrorXCell = null; // Absolute pixel coords
var setCurrentHoveredMirrorXCell = function (value) {
    exports.currentHoveredMirrorXCell = value;
};
exports.setCurrentHoveredMirrorXCell = setCurrentHoveredMirrorXCell;
exports.currentHoveredMirrorYCell = null; // Absolute pixel coords
var setCurrentHoveredMirrorYCell = function (value) {
    exports.currentHoveredMirrorYCell = value;
};
exports.setCurrentHoveredMirrorYCell = setCurrentHoveredMirrorYCell;
exports.mockUserCursors = [];
exports.animationFrameId = null;
var setAnimationFrameId = function (value) {
    exports.animationFrameId = value;
};
exports.setAnimationFrameId = setAnimationFrameId;
exports.mainCursorProximityFactor = 0.5;
var setMainCursorProximityFactor = function (value) {
    exports.mainCursorProximityFactor = value;
};
exports.setMainCursorProximityFactor = setMainCursorProximityFactor;
exports.stampChance = config.STAMP_CHANCE;
var setStampChance = function (value) {
    exports.stampChance = value;
};
exports.setStampChance = setStampChance;
exports.postSweepFlowerDelayDuration = config.POST_SWEEP_FLOWER_DELAY_DURATION; // ms
var setPostSweepFlowerDelayDuration = function (value) {
    exports.postSweepFlowerDelayDuration = value;
};
exports.setPostSweepFlowerDelayDuration = setPostSweepFlowerDelayDuration;
exports.postSweepFlowerDelayActiveUntil = 0; // timestamp
var setPostSweepFlowerDelayActiveUntil = function (value) {
    exports.postSweepFlowerDelayActiveUntil = value;
};
exports.setPostSweepFlowerDelayActiveUntil = setPostSweepFlowerDelayActiveUntil;
exports.logicalGridCells = {
    offsetX: 0,
    offsetY: 0,
    numCols: 0,
    numRows: 0,
    totalWidthPx: 0,
    totalHeightPx: 0
};
var setLogicalGridCells = function (value) {
    exports.logicalGridCells = value;
};
exports.setLogicalGridCells = setLogicalGridCells;
// Initial Load Delays State
exports.initialCursorVisibilityDelayEndTime = 0;
var setInitialCursorVisibilityDelayEndTime = function (value) {
    exports.initialCursorVisibilityDelayEndTime = value;
};
exports.setInitialCursorVisibilityDelayEndTime = setInitialCursorVisibilityDelayEndTime;
exports.initialFlowerCreationDelayEndTime = 0;
var setInitialFlowerCreationDelayEndTime = function (value) {
    exports.initialFlowerCreationDelayEndTime = value;
};
exports.setInitialFlowerCreationDelayEndTime = setInitialFlowerCreationDelayEndTime;
// Symmetrical Special Color State
exports.enableSymmetricalSpecialColor = config.ENABLE_SYMMETRICAL_SPECIAL_COLOR;
var setEnableSymmetricalSpecialColor = function (value) {
    exports.enableSymmetricalSpecialColor = value;
};
exports.setEnableSymmetricalSpecialColor = setEnableSymmetricalSpecialColor;
// Calculated Segment Size
exports.calculatedSegmentSize = 4;
var setCalculatedSegmentSize = function (value) {
    exports.calculatedSegmentSize = value;
};
exports.setCalculatedSegmentSize = setCalculatedSegmentSize;
// Layout mode
exports.isMobileLayout = false;
var setIsMobileLayout = function (value) {
    exports.isMobileLayout = value;
};
exports.setIsMobileLayout = setIsMobileLayout;
exports.imageLayoutMode = null;
var setImageLayoutMode = function (value) {
    exports.imageLayoutMode = value;
};
exports.setImageLayoutMode = setImageLayoutMode;
exports.needsImageReload = false;
var setNeedsImageReload = function (value) {
    exports.needsImageReload = value;
};
exports.setNeedsImageReload = setNeedsImageReload;
